export default __webpack_public_path__ + "static/media/TopGator1.bf6b4ef4.jpg";